export const NUMBER_FORMAT = /^[+-]?\d*\.?\d+(?:[Ee][+-]?\d+)?$/;